import {
  SearchFilters,
  payFullRange,
  payMonthlyRange,
} from '@cinch-nx/data-search'

/*
 * Price segments resolve for any value, so /197-per-month serves results.
 * Served always, indexed only for values the price filter offers.
 */
export const isIndexablePriceSegment = (
  pathSegmentFilters: Partial<SearchFilters>,
): boolean => {
  const monthlyPrice = pathSegmentFilters.monthlyPrice?.[0]
  const totalPrice = pathSegmentFilters.totalPrice?.[0]

  if (monthlyPrice !== undefined) {
    return payMonthlyRange.some((option) => `${option.value}` === monthlyPrice)
  }

  if (totalPrice !== undefined) {
    return payFullRange.some((option) => `${option.value}` === totalPrice)
  }

  // Not a price page, so this rule has nothing to say about it
  return true
}

export const hasPriceSegment = (
  pathSegmentFilters: Partial<SearchFilters>,
): boolean =>
  (pathSegmentFilters.monthlyPrice?.length ?? 0) > 0 ||
  (pathSegmentFilters.totalPrice?.length ?? 0) > 0
